import type { PageProps } from 'gatsby';
import React from 'react';

import { FeatureGuard } from '@components/Guards';

import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { useSession } from '@hooks/useSession';

import NewAccount from '@views/Admin/NewAccount/index';

export default function AdminNewAccountPage({ params }: PageProps) {
  const { flags } = useFeatureFlags();
  const {
    state: { isOrg, loggedInProfile },
  } = useSession();

  const parent_account_id = isOrg ? loggedInProfile?.account_id : undefined;
  const can_import_users =
    flags.isUserListBulkImportsEnabled || flags.isUserInitiateBulkImportEnabled;

  return (
    <FeatureGuard feature={'AdminCreateClient'}>
      <NewAccount
        {...params}
        can_import_users={can_import_users}
        parent_account_id={parent_account_id}
      />
    </FeatureGuard>
  );
}
